import {
  type FindReplaceRule,
  IFindAndReplaceRuleType as RuleType,
  type Selector,
} from '@carboncopyco/types';
import { ImageReplaceControls } from './ImageReplaceControls';
import { LinkReplaceControls } from './LinkFindAndReplace';
import { TextReplaceControls } from './TextReplaceControls';

export type TFindAndReplaceRuleStatus =
  | 'idle'
  | 'submitting'
  | 'success'
  | 'error';

export type IFindAndReplaceRuleState<T extends FindReplaceRule> = {
  submitting: boolean;
  editMode: boolean;
  error: string | null;
  setStatus: (status: TFindAndReplaceRuleStatus) => void;
  onSubmit: (value: Partial<T>, selectors?: Selector[]) => Promise<void>;
  rule?: T;
  rules?: FindReplaceRule[];
  onCancel?: () => void;
  autoFocus?: boolean;
  onFocus?: (e: React.FocusEvent<HTMLElement>) => void;
};

export const ruleToControls: Record<
  RuleType,
  React.FunctionComponent<Partial<IFindAndReplaceRuleState<FindReplaceRule>>>
> = {
  [RuleType.replaceText]: TextReplaceControls,
  [RuleType.replaceImage]: ImageReplaceControls,
  [RuleType.replaceImageWithVariable]: ImageReplaceControls,
  [RuleType.snippet]: null,
  [RuleType.replaceLink]: LinkReplaceControls,
};
